import { Middleware } from 'redux';
import { MiddlewareProcessor, middleWareWrapper } from './middleware-utils';

export let isNewDesign: boolean;

/**
 * Middleware that checks the application configuration for legacy new admin design.
 */
const newDesignMiddlewareProcessor: MiddlewareProcessor = (
  api,
  next,
  action
) => {
  const {
    ui: { config }
  }: CMx.ApplicationState = api.getState();

  isNewDesign = config.isNewDesign;

  return next(action);
};
const newDesignMiddleware: Middleware = middleWareWrapper(
  newDesignMiddlewareProcessor
);

export default newDesignMiddleware;
